import { render, staticRenderFns } from "./ArticleVideoModeButton.vue?vue&type=template&id=56d17504&"
import script from "./ArticleVideoModeButton.vue?vue&type=script&lang=ts&"
export * from "./ArticleVideoModeButton.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleVideoModeButton.vue?vue&type=style&index=0&id=56d17504&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports